export default __webpack_public_path__ + "static/realWorldImage3-a6d03b5dd1ce3eb307d9f35da627740d.webp";